var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParkingP1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 349.996,
  height: 333.327,
  viewBox: "0 0 349.996 333.327"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "parking_P1_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 249.995h262.497V0H0z"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0072ce",
  d: "m0 0 .005 333.327h349.99V0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#parking_P1_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 333.327)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M184.082 118.515V26.183h-18.516v71.305l-15.61-12.7-9.264 12.04 26.988 21.687zM94.02 157.17h-9.65v41.958h9.65c14.18 0 26.2-5.512 26.2-21.472 0-15.953-12.41-20.485-26.2-20.485m-2.368 63.63H56.786V83.307H84.37V135.5h11.614c29.554 0 52.993 11.624 52.993 43.732 0 32.9-27.378 41.57-57.325 41.57"
}))));
export default SvgParkingP1;